var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "about" }, [
    _c("h1", [_vm._v("Configurations")]),
    _c("span", [_vm._v(" API : " + _vm._s(_vm.baseURL))]),
    _c("div", [
      _c(
        "button",
        {
          staticClass: "btn btn-primary btn-lg btn-block btn-round",
          on: {
            click: function($event) {
              return _vm.nettoyerCache()
            }
          }
        },
        [_vm._v("Nettoyer le cache")]
      ),
      _c(
        "button",
        {
          staticClass: "btn btn-primary btn-lg btn-block btn-round",
          on: {
            click: function($event) {
              return _vm.genererErreur()
            }
          }
        },
        [_vm._v("Générer une erreur")]
      )
    ]),
    _c("h1", [_vm._v(" Dernières actions")]),
    _c(
      "div",
      { staticClass: "col-md-4" },
      [
        _c("b-table", {
          attrs: { striped: "", hover: "", items: _vm.dernieresActions }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }